import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';

export default class TKHeadingNav extends TKCustomElementFactory {
    heading: string;
    targetSelector: string;

    constructor() {
        super();
        this.heading = this.getAttribute('data-tk-heading') || 'h2';
        this.targetSelector = this.getAttribute('data-tk-target-selector') || 'main';
    }

    connectedCallback() {
        this.render();
        this.setupHeadings();
    }

    render() {
        const rect = this.getBoundingClientRectOfTarget();
        if (!rect) return;
        this.style.top = `${rect.top}px`;
    }

    setupHeadings() {
        const container = document.querySelector(this.targetSelector);
        if (!container) return;

        const headings = Array.from(
            container.querySelectorAll<HTMLHeadingElement>(`${this.heading},[data-tk-heading-nav-item-title]`),
        );
        const nav = this.querySelector('[data-tk-navigation-element]');
        const underline = this.querySelector<HTMLElement>('[data-tk-underline-element]');
        if (!underline) return;
        const rect = this.getBoundingClientRectOfTarget();
        const { height } = this.getBoundingClientRect();

        nav?.querySelectorAll('.nav-item').forEach((e) => e.remove());

        headings.forEach((heading) => {
            heading.style.scrollMarginTop = `${(rect?.top || 0) + height}px`;
            const item = document.createElement('div');
            item.classList.add('tk-button', 'tk-button--link');
            item.setAttribute('data-tk-nav-item-element', '');
            item.textContent = heading.hasAttribute('data-tk-heading-nav-item-title')
                ? heading.getAttribute('data-tk-heading-nav-item-title')
                : heading.textContent;
            item.addEventListener('click', () => {
                heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
            nav?.appendChild(item);
        });

        const navItems = Array.from(this.querySelectorAll<HTMLElement>('[data-tk-nav-item-element]'));
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    const index = headings.indexOf(entry.target as HTMLHeadingElement);
                    if (entry.isIntersecting) {
                        this.activateItem(navItems[index], underline);
                    }
                });
            },
            {
                threshold: 0,
            },
        );
        headings.forEach((h) => observer.observe(h));
    }

    activateItem(item: HTMLElement, underline: HTMLElement) {
        if (!item || !underline) return;
        const rect = item.getBoundingClientRect();
        const navRect = item.parentElement?.getBoundingClientRect();
        underline.style.left = `${rect.left - (navRect?.left || 0)}px`;
        underline.style.width = `${rect.width}px`;
    }

    getBoundingClientRectOfTarget() {
        const target = document.querySelector(this.targetSelector);
        if (!target) return;
        return target.getBoundingClientRect();
    }
}
